import { graphql } from '@/gql';

graphql(`
  fragment MultiOrderPartialFragment on PaginatedDeliveryOrderResponse {
    count
    rows {
      id
      callerId
      caller {
        firstName
        lastName
        phoneNumber
        isRequiredMonitoringGourmetOrder
      }
      orderId
      preferredPhoneNumber
      clientName
      isRedelivery
      originalOrderId
      natureOfComplaint
      operatorId
      operator {
        firstName
        lastName
      }
      scheduleId
      total
      service
      serviceAccount {
        email
        password
        phoneNumber
      }
      storeOrder {
        title
        subtitle
        phoneNumber
        isManualOrder
        address {
          formattedAddress
        }
        estimate {
          total
          serviceEstimateReference
          charges {
            title
            value
            originalValue
            tooltips {
              title
              value
            }
          }
          timeEstimate {
            min
            max
          }
          chargeOptions {
            plan
            tier
            applyDiscountedFee
            noServiceFee
            doNotCharge
            chargeNow
            reason
          }
          address {
            formattedAddress
            streetAddress
            streetAddress2
            city
            state
            postalCode
          }
          items {
            item {
              title
              price
              quantity
            }
            options {
              id
              title
              subtitle
              max
              min
              minAggregateOptionsQuantity
              maxAggregateOptionsQuantity
              type
              selectedValues
              originalStructure
            }
          }
          orderOptions {
            storeInstructions
            deliveryInstructions
            dropoffOptionId
          }
        }
      }
      orderStatus {
        currentProgress
        title
        subtitle
        description
        agent {
          phoneNumber
          name
        }
        locationMarkers {
          title
          latitude
          longitude
        }
      }
      orderCharge {
        total
        card {
          total
          complete
          cardLast4
        }
        credits {
          total
          complete
        }
        expiringCredits {
          expiringCreditId
          complete
          total
        }
        refunds {
          transactionId
          credits
          costs
          refundId
          refundCostAsCredits
        }
      }
      relatedPath {
        orderResolution {
          resolvedByOrderID
          resolvedOrderID
          redeliveryByOrderId
          resolvedWithoutReorder
        }
      }
      status
      paidStatus
      isConfirmedMonitoringCall
      rateInfo {
        submittedAt
        submitById
        rateList {
          target {
            targetType
            targetId
          }
          starRating
          reviewText
          tagList {
            tagId
            tagName
          }
        }
      }
      transactionId
      isNotReceivedOrder
      needLoveId
      createdAt
      updatedAt
    }
  }
`);
